module.exports = __webpack_public_path__ + "img/KSC01903.a088f4e0.jpg";